import { createClass as _createClass, classCallCheck as _classCallCheck } from "../_virtual/_rollupPluginBabelHelpers.js";
var OPUS = /* @__PURE__ */ function() {
  function OPUS2() {
    _classCallCheck(this, OPUS2);
  }
  _createClass(OPUS2, null, [{
    key: "getFrameDuration",
    value: function getFrameDuration(samples) {
      return 20;
    }
  }, {
    key: "parseHeaderPackets",
    value: function parseHeaderPackets(data) {
      if (!data.length)
        return;
      var dv = new DataView(data.buffer, data.byteOffset, data.byteLength);
      var magicSignature = "";
      for (var i = 0; i < 8; i++) {
        magicSignature += String.fromCodePoint(data[i]);
      }
      if (magicSignature !== "OpusHead") {
        throw new Error("Invalid Opus MagicSignature");
      }
      var channelCount = data[9];
      console.log("Pre-skip", data[10], data[11]);
      var sampleRate = dv.getUint32(12, true);
      var outputGain = dv.getInt16(16, true);
      if (!sampleRate)
        return;
      var codec = "opus";
      var originCodec = "opus";
      var config = new Uint8Array(data.buffer, data.byteOffset + 8, data.byteLength - 8);
      return {
        outputGain,
        sampleRate,
        channelCount,
        config,
        codec,
        originCodec
      };
    }
  }]);
  return OPUS2;
}();
export { OPUS };
